import React, { useEffect, useState ,useRef} from 'react';
import axios from 'axios';
import {
  Box,
  Input,
  Table,
  TableCaption,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Button,Text,
  Image,useDisclosure, AlertDialogBody,
  AlertDialog,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay
} from "@chakra-ui/react";
import toast from 'react-hot-toast';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { set } from 'lodash';
import WineUpdateModal from './wineUpdateModal';
import Cookie from 'js-cookie';

const WineData=()=>{
  const token=Cookie.get('token')
  
    const [data,setData]=useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [isOpen1,setIsOpen]=useState(false)
    const {isOpen, onOpen, onClose} = useDisclosure({});
    const [wineData,setWineData]=useState([])
    const [category,setCategory]=useState([]);
    const [Id,setId]=useState(null);
    const [type,setType]=useState([])
    const customerId=localStorage.getItem('customerId')
    const fetchData = async () => {
      try {
        const response = await axios.get(`https://api.rcb.tdrsoftware.in/api/getWineData/${customerId}`);
        const wines = response.data.wine;
         setData(wines);
      } catch (error) {
        
      }
        
    //const {isOpen, onOpen, onClose} = useDisclosure({});
        // const updatedWines = await Promise.all(
        //   wines.map(async (room) => {
        //     if (room.itemPhoto) {
        //       // Check if the image is already cached
    
              
        //         try {
        //           const imageResponse = await axios.get(`https://api.rcb.tdrsoftware.in/get-image/${room.itemPhoto}`, {
        //             responseType: 'blob', // Assuming the image is returned as a blob
        //           });
    
        //           // Create a blob URL for the image
        //           //cachedUrl = URL.createObjectURL(imageResponse.data);
                  
        //           // Cache the URL for future use
        //           room.imageUrl=URL.createObjectURL(imageResponse.data)
                 
        //         } catch (error) {
        //           console.error(`Error fetching image for room: ${room.image}`, error);
        //           room.imageUrl = null; // Fallback in case of error
        //         }
              
    
        //        // Assign the cached or fetched URL
        //     } else {
        //       room.imageUrl = null; // Handle cases where image is missing
        //     }
        //     return room;
        //   })
        // );
    
       
      };
      const getWine=async(id)=>{
        
        try {
        const response=await axios.get(`https://api.rcb.tdrsoftware.in/api/getWineDataById/${customerId}/${id}`);
        setWineData(response.data.wine)
        setId(id)
        onOpen()
      } catch (error) {
       // toast.error(error.message)
      }
      }
      const deleteModal=async(id)=>{
        try {
          const response=await axios.delete(`https://api.rcb.tdrsoftware.in/api/deleteWineData/${customerId}/${id}`);
          toast.success(response.data.message)
          fetchData()
        } catch (error) {
          toast.error(error.message)
        }
      }
      const cancelRef=useRef();
      const DeleteModal = (id) => {
        setDeleteItemId(id);
        setIsOpen(true);
      };
    
      const onClose1 = () => {
        setIsOpen(false);
        setDeleteItemId(null);
      };

      const categoryData=async()=>{
        try {
           const response=await axios.get(`https://api.rcb.tdrsoftware.in/api/getCategoryData/${customerId}`);
           setCategory(response.data.category)
           console.log(response.data.category)
        } catch (error) {
           toast.error(error.message)
        }
   }
   const handleDelete = async () => {
    try {
      const response = await axios.delete(`https://api.rcb.tdrsoftware.in/api/deleteWineData/${customerId}/${deleteItemId}?customerId=${customerId}`,{
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      
        toast.success('Data deleted successfully');
        onClose1()
        fetchData();
        
    } catch (error) {
      if(error.response && error.response.status === 403) {
        toast.error(error.response.data.message);
      } else {
        toast.error('An error occurred while deleting the data');
      }
    }
  }
   const fetchTypeData=async()=>{
    try {
      const response=await axios.get(`https://api.rcb.tdrsoftware.in/api/getWineTypeData/${customerId}`);
    //  console.log(response.data.type,'type')
      setType(response.data.type)
    } catch (error) {
      console.error(error.message)
    }
  }


      console.log(data,'data');
      const categories=category.map((item)=>item.categoryName);
      const types=type.map((item)=>item.name)
      console.log(categories,'categories')

      useEffect(()=>{
        fetchData()
        categoryData()
        fetchTypeData()
      },[customerId])

      return (
        <Box width='100%' overflow='scroll'>
        <WineUpdateModal isOpen={isOpen} onClose={onClose} customerId={customerId} onOpen={onOpen} category={categories} type={types} data={wineData} id={Id} setSelectId={setId} />
            <TableContainer width='full'>

        <Table size='sm' variant='striped' colorScheme='green'>
          <TableCaption>Wine Data</TableCaption>
          <Thead>
            <Tr>
              <Th>Item Name</Th>
              <Th>Item Code</Th>
              <Th>Short Code</Th>
              <Th>Category</Th>
              <Th>Item Photo</Th>
              <Th>Item Type</Th>
              <Th>MRP</Th>
              <Th>BTL Rate</Th>
              <Th>Net Rate</Th>
              <Th>Ac Full Rate</Th>
              <Th>Ac Half Rate</Th>
              <Th>Non-Ac Full Rate</Th>
              <Th>Non-Ac Half Rate</Th>
              <Th>Stock in Ml</Th>
              <Th>Closing  Stock</Th>
              <Th>Edit</Th>
              <Th>Delete</Th>
            </Tr>
          </Thead>
          <Tbody>
            {data.map((wine, index) => (
              <Tr key={index}>
                <Td>{wine.name}</Td>
                <Td>{wine.itemCode}</Td>
                <Td>{wine.code}</Td>
                <Td>{wine.category}</Td>
                <Td>
                    <Image src={wine.imageUrl} w='100' h='100'/>
                    </Td>
                <Td>{wine.itemType}</Td>
                <Td>{wine.mrp}</Td>
                <Td>{wine.purchaseRate}</Td>
                <Td>
                 {wine.netRate}
                </Td>
                <Td>{wine.acRate}</Td>
                <Td>{wine.acHalfRate}</Td>
                <Td>{wine.nonAcRate}</Td>
                <Td>{wine.nonAcHalfRate}</Td>
                <Td>{wine.stockMl}</Td>
                <Td>{wine.closingStock}</Td>
                <Td> <Button colorScheme='green' onClick={() => getWine(wine._id)}><FaEdit/></Button></Td>
                <Td> <Button colorScheme='red' onClick={() => DeleteModal(wine._id)}><FaTrash/></Button></Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
      <AlertDialog isOpen={isOpen1} leastDestructiveRef={cancelRef} onClose={onClose1}>
      <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Confirm Deletion
            </AlertDialogHeader>

            <AlertDialogBody>Are you sure you want to delete this item?</AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose1}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={handleDelete} ml={3}>
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
        </Box>
      )
}
export default WineData